import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '~/core/classes/auth/auth.guard';

//******************************************************************************
//  App Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { RecordDetailComponent } from '~/pages/record-detail/record-detail.component';

export const routes: any[] = [
    {
        path: '',
        title: 'SDS IntelliRev Validator',
        isNav: true,
        component: HomeComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'requests',
        title: 'Requests',
        icon: 'assignment',
        isNav: true,
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: { tab: 'requests' }
    },
    {
        path: 'record/:id',
        title: 'Record Details',
        isNav: false,
        component: RecordDetailComponent,
        canActivate: [AuthGuard]
    },
   
    {
        path: '**',
        redirectTo: 'notfound',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRouting { }
